import * as yup from 'yup'

export const driverJurisdictionValidation = (fieldName: string) =>
  yup
    .string()
    .transform(value => (typeof value === 'string' ? value.trim().toUpperCase() : value))
    .max(2, `${fieldName} cannot be more than 2 characters.`)
    .matches(/^[A-Z-]*$/, `${fieldName} can contain only letters A-Z or hyphens.`)
    .nullable()
